export function isEnvironment(env: string) {
  return import.meta.env.VITE_ENV?.trim() === env
}